let cachedConfig = null;

function getTradeInConfig() {
    if (cachedConfig) return cachedConfig;

    const tradeInDataScript = document.getElementById('trade-in-data');
    if (!tradeInDataScript) return null;

    try {
        const config = JSON.parse(tradeInDataScript.textContent);
        cachedConfig = {
            currencyCode: config.currencyCode || 'COP',
            tradeInData: config.tradeInProductData || [],
            editText: config.editText || 'edit',
            modalId: config.modalId,
            descriptionTemplate: config.descriptionTemplate || 'Get up to {highest_available_value} for your device'
        };
        return cachedConfig;
    } catch (error) {
        console.error('Error parsing trade-in config:', error);
        return null;
    }
}

function formatTradeInPrice(price, currencyCode = null, isHighestValue = false) {
    if (!price) return '';

    if (!currencyCode) {
        const config = getTradeInConfig();
        currencyCode = config?.currencyCode || 'COP';
    }

    let numericPrice;
    if (typeof price === 'string') {
        const cleanPrice = price.replace(/[^0-9.-]+/g, '');
        numericPrice = parseFloat(cleanPrice) || 0;
    } else {
        numericPrice = parseFloat(price) || 0;
    }

    if (isNaN(numericPrice) || numericPrice <= 0) return '';

    if (isHighestValue) {
        numericPrice = Math.round(numericPrice / 100);
    } else {
        numericPrice = Math.round(numericPrice);
    }

    let currencySymbol = '$';
    if (currencyCode.includes('PEN')) {
        currencySymbol = 'S/ ';
    }

    const formattedNumber = numericPrice.toLocaleString('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true
    });

    return currencySymbol + formattedNumber;
}

function updateTradeInDescriptions() {
    const config = getTradeInConfig();

    if (!config?.tradeInData || !Array.isArray(config.tradeInData)) {
        return;
    }

    const tradeInData = config.tradeInData;
    let highestValue = 0;

    tradeInData.forEach(device => {
        const grades = ['gradeA', 'gradeB', 'gradeC', 'gradeD'];
        grades.forEach(grade => {
            if (device[grade] && device[grade] !== '') {
                const numericValue = parseInt(device[grade].toString().replace(/[^0-9]/g, '')) || 0;
                if (numericValue > highestValue) {
                    highestValue = numericValue;
                }
            }
        });
    });

    if (highestValue > 0) {
        const formattedHighestValue = formatTradeInPrice(highestValue, null, true);

        // Actualizar solo el párrafo de descripción del modal (clase "description").
        // MOXIE: filtro explícito por clase para evitar que el span .value-amount sea tocado
        // aunque el Liquid viejo aún tenga data-modified-description en él.
        const modalDescriptions = document.querySelectorAll('p.description[data-modified-description]');
        modalDescriptions.forEach(element => {
            const originalText = element.getAttribute('data-modified-description');
            if (originalText) {
                let updatedText;
                if (originalText.includes('${{') || originalText.includes('highest_available_value')) {
                    updatedText = originalText.replace(/\$\{\{\s*highest_available_value\s*\}\}/g, formattedHighestValue);
                } else {
                    updatedText = originalText.replace(/\$[\d,.]+(\s+[A-Z]{3})?/g, formattedHighestValue);
                }
                element.textContent = updatedText;
            }
        });

        // MOXIE: actualizar el bloque PDP con su propio template (trade_in_pdp_description),
        // independiente del texto del modal para evitar que ambos se sobreescriban mutuamente.
        const pdpDescription = document.querySelector('.trade-in__pdp-description');
        if (pdpDescription && config.descriptionTemplate) {
            const template = config.descriptionTemplate;
            let pdpText;
            if (template.includes('${{') || template.includes('highest_available_value')) {
                pdpText = template.replace(/\$\{\{\s*highest_available_value\s*\}\}/g, formattedHighestValue);
            } else {
                pdpText = template.replace(/\$[\d,.]+(\s+[A-Z]{3})?/g, formattedHighestValue);
            }
            pdpDescription.innerText = pdpText;
        }
    }
}

// MOXIE: Plan Cambialo cuando el producto YA esta en el carrito.
// El flujo PDP solo escribe los inputs ocultos, que product-form.js lee dentro del
// click de "Agregar al carrito". Si el producto ya se agrego, ese click no vuelve a
// ocurrir y el trade-in nunca llega al carrito. Aqui reutilizamos el handler delegado
// `.add-cart-trade-in` de product-form.js (que ya hace /cart/change.js) en vez de
// duplicar esa implementacion.
async function applyTradeInToExistingCartItem(button, tradeInValue, tradeInDevice) {
    if (!window.jQuery) return;

    const variantInput = document.querySelector('#main-product-variant');
    const variantId = variantInput ? parseInt(variantInput.value, 10) : NaN;
    if (!variantId) return;

    let cart;
    try {
        cart = await fetch(`${window.Shopify.routes.root}cart.js`).then(res => res.json());
    } catch (error) {
        console.error('Error reading cart for trade-in:', error);
        return;
    }

    // Ultimo line item de esta variante que aun no tenga trade-in aplicado.
    // Se recorre al reves para no pisar una unidad que ya lo tenga.
    const items = cart?.items || [];
    let lineIndex = -1;
    for (let i = items.length - 1; i >= 0; i--) {
        if (items[i].variant_id === variantId && !items[i].properties?._tradeIn_device) {
            lineIndex = i;
            break;
        }
    }

    // No esta en el carrito: se conserva el flujo PDP actual (inputs ocultos + /cart/add.js)
    if (lineIndex === -1) return;

    const item = items[lineIndex];

    if (!button.isConnected) {
        console.warn('Trade-in button detached; skipping cart update.');
        return;
    }

    // El handler de product-form.js lee todo con jQuery .data(), que cachea y castea
    // los atributos data-*. Se asignan explicitamente para no depender de setAttribute
    // y para que el valor llegue como string (evita perder los decimales del precio).
    const $button = window.jQuery(button);
    $button.data('tradeInValue', String(tradeInValue));
    $button.data('tradeInDevice', String(tradeInDevice));
    $button.data('itemProperties', { ...item.properties });
    $button.data('forproduct', lineIndex + 1);
    $button.data('quantityparent', item.quantity);

    // El click original ya termino de propagar (el lookup del carrito es async), asi que
    // agregar la clase no basta: hay que emitir un segundo click para que llegue al
    // handler delegado en document. El flag evita que addButtonClickHandler se reejecute.
    button.dataset.tradeInCartSync = 'true';
    button.classList.add('add-cart-trade-in');
    button.click();
}

let deviceSearchInstances = new Map();

function initializeDeviceSearch() {
    const searchInputs = document.querySelectorAll('.device-search-input');

    searchInputs.forEach(searchInput => {
        const modalId = searchInput.id.split('-').pop();

        const searchResults = document.getElementById(`device-search-results-${modalId}`);
        const gradeOptions = document.getElementById(`grade-options-${modalId}`);

        const modalContainer = searchInput.closest('.trade-in__modal-content');
        const tradeInValueInput = modalContainer ?
            modalContainer.querySelector('#trade-in-value') :
            document.getElementById('trade-in-value');
        const tradeInDeviceInput = modalContainer ?
            modalContainer.querySelector('#trade-in-device') :
            document.getElementById('trade-in-device');
        const valueAmountSpans = document.querySelectorAll('.js-trade-in-value-amount');

        const addButton = modalContainer ?
            modalContainer.querySelector('.add-to-product, .add-cart-trade-in, .js-add-to-product') :
            document.querySelector('.add-to-product, .add-cart-trade-in, .js-add-to-product');

        if (deviceSearchInstances.has(modalId)) {
            const existingInstance = deviceSearchInstances.get(modalId);
            if (existingInstance.cleanup) {
                existingInstance.cleanup();
            }
        }

        let selectedDevice = null;

        if (tradeInDeviceInput && tradeInDeviceInput.value && tradeInValueInput && tradeInValueInput.value !== '0') {
            const deviceName = tradeInDeviceInput.value;
            const config = getTradeInConfig();
            const deviceData = config?.tradeInData?.find(device => device.model === deviceName);

            if (deviceData) {
                selectedDevice = {
                    model: deviceData.model,
                    vendor: deviceData.vendor || deviceData.brand || '',
                    gradeA: deviceData.gradeA,
                    gradeB: deviceData.gradeB,
                    gradeC: deviceData.gradeC,
                    gradeD: deviceData.gradeD
                };

                if (searchInput) {
                    searchInput.value = selectedDevice.model;
                }
            }
        }

        const inputHandler = function () {
            const query = this.value.toLowerCase();
            const deviceOptions = searchResults.querySelectorAll('.device-option');
            let hasVisibleOptions = false;

            deviceOptions.forEach(option => {
                const searchTerms = option.dataset.searchTerms ? option.dataset.searchTerms.toLowerCase() : '';
                const displayText = option.textContent.toLowerCase();

                const matchesSearchTerms = searchTerms.includes(query);
                const matchesDisplayText = displayText.includes(query);

                if ((matchesSearchTerms || matchesDisplayText) && query.length > 0) {
                    option.style.display = 'block';
                    hasVisibleOptions = true;
                } else {
                    option.style.display = 'none';
                }
            });

            searchResults.style.display = hasVisibleOptions && query.length > 0 ? 'block' : 'none';
        };

        const clickHandler = function (e) {
            if (e.target.classList.contains('device-option')) {
                const clickedModel = e.target.dataset.model;
                const clickedVendor = e.target.dataset.vendor;

                const config = getTradeInConfig();
                const deviceData = config?.tradeInData?.find(device =>
                    device.model === clickedModel &&
                    (device.vendor === clickedVendor || device.brand === clickedVendor)
                );

                if (deviceData) {
                    selectedDevice = {
                        model: deviceData.model,
                        vendor: deviceData.vendor || deviceData.brand || '',
                        gradeA: deviceData.gradeA,
                        gradeB: deviceData.gradeB,
                        gradeC: deviceData.gradeC,
                        gradeD: deviceData.gradeD
                    };

                    searchInput.value = selectedDevice.model;
                    searchResults.style.display = 'none';

                    if (tradeInDeviceInput) {
                        tradeInDeviceInput.value = selectedDevice.model;
                    }
                    updatePrice();
                }
            }
        };

        const documentClickHandler = function (e) {
            // MOXIE: ignorar clicks emitidos por codigo. El autoplay del carrusel de
            // financiacion (custom.js scrollToCard) hace targetCard.click() cada 3s y, al
            // burbujear hasta document, cerraba el dropdown mientras el usuario escribia.
            if (!e.isTrusted) return;
            if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
                searchResults.style.display = 'none';
            }
        };

        if (searchInput && searchResults) {
            searchInput.addEventListener('input', inputHandler);
            searchResults.addEventListener('click', clickHandler);
            document.addEventListener('click', documentClickHandler);
        }

        const gradeChangeHandler = function (e) {
            if (e.target.type === 'radio') {
                updatePrice();
                const radios = gradeOptions.querySelectorAll('.radio');
                radios.forEach(radio => radio.classList.remove('active'));
                e.target.closest('.radio').classList.add('active');
            }
        };

        if (gradeOptions) {
            gradeOptions.addEventListener('change', gradeChangeHandler);
        }

        function updatePrice() {
            const selectedGrade = gradeOptions ? gradeOptions.querySelector('input[type="radio"]:checked') : null;

            if (!selectedGrade || !selectedDevice) {
                if (addButton) {
                    addButton.setAttribute('disabled', 'disabled');
                }
                return;
            }

            const gradeValue = selectedGrade.value;
            const tradeInPrice = selectedDevice[gradeValue];

            if (addButton) {
                addButton.setAttribute('data-trade-in-device', selectedDevice.model);
                addButton.removeAttribute('disabled');
                addButton.disabled = false;

                if (tradeInPrice) {
                    addButton.setAttribute('data-trade-in-value', tradeInPrice);
                } else {
                    addButton.setAttribute('data-trade-in-value', '0');
                }
            }

            if (tradeInPrice && tradeInValueInput) {
                tradeInValueInput.value = tradeInPrice;

                if (valueAmountSpans && valueAmountSpans.length) {
                    valueAmountSpans.forEach(valueAmountSpan => {
                        const formattedPrice = formatTradeInPrice(tradeInPrice);
                        valueAmountSpan.textContent = formattedPrice;
                        valueAmountSpan.setAttribute('data-trade-in-value', tradeInPrice);
                        valueAmountSpan.parentElement.style.display = 'block';
                        // MOXIE: el mensaje del PDP trae .hidden (display: none !important en base.css)
                        valueAmountSpan.parentElement.classList.remove('hidden');
                    });
                }
            }
        }

        // Click handler del botón "Usar mi celular como parte de pago"
        // trade-in-scripts.liquid no lo adjunta porque requiere .select (legacy) que ya no existe
        function addButtonClickHandler(e) {
            // Click sintetico emitido por applyTradeInToExistingCartItem: dejar que siga
            // propagando hasta el handler delegado `.add-cart-trade-in` sin reprocesarlo.
            if (e.currentTarget.dataset.tradeInCartSync === 'true') {
                // Se consume una sola vez: si /cart/change.js falla no hay reload y el flag
                // quedaria pegado, dejando el boton inservible y con .data() obsoleta.
                delete e.currentTarget.dataset.tradeInCartSync;
                return;
            }

            const tradeInValue = e.currentTarget.getAttribute('data-trade-in-value');
            const tradeInDevice = e.currentTarget.getAttribute('data-trade-in-device');

            if (!tradeInValue || !tradeInDevice) return;

            // Actualizar inputs ocultos del formulario PDP
            const selectedValueInput = document.querySelector('#selected-trade-in-value');
            const selectedDeviceInput = document.querySelector('#selected-trade-in-device');
            if (selectedValueInput) selectedValueInput.value = tradeInValue;
            if (selectedDeviceInput) selectedDeviceInput.value = tradeInDevice;

            // Actualizar spans de valor visible
            const valueSpans = document.querySelectorAll('.js-trade-in-value-amount');
            valueSpans.forEach(function (span) {
                span.textContent = formatTradeInPrice(parseFloat(tradeInValue));
                span.setAttribute('data-trade-in-value', tradeInValue);
                if (span.parentElement) {
                    span.parentElement.style.display = 'block';
                    span.parentElement.classList.remove('hidden');
                }
            });

            // Actualizar label del trigger en PDP al texto de edición
            const config = getTradeInConfig();
            const editText = config?.editText;
            const triggerInput = document.querySelector('.js-product-option-form .js-trade-in-modal-trigger-input');
            const triggerLabel = document.querySelector('.js-product-option-form .js-trade-in-modal-trigger-input + label');
            if (triggerInput && triggerLabel && editText) {
                triggerLabel.innerText = editText;
                triggerInput.setAttribute('checked', 'checked');
            }

            // MOXIE: si el producto ya esta en el carrito, aplicar el trade-in al line item
            // existente. Si no lo esta, esta llamada no hace nada y queda el flujo de siempre.
            applyTradeInToExistingCartItem(e.currentTarget, tradeInValue, tradeInDevice);

            // Cerrar el modal: Seedkit mueve el ac-modal al container .modal en body en runtime
            // Desde el botón subimos con .closest('.modal') para encontrar ese container
            const modalDialog = e.currentTarget.closest('.modal');
            const closeBtn = modalDialog?.querySelector('button.modal-close-button, [data-modal-element-close-button]');
            if (closeBtn) closeBtn.click();
        }

        if (addButton) {
            addButton.addEventListener('click', addButtonClickHandler);
        }

        deviceSearchInstances.set(modalId, {
            selectedDevice: () => selectedDevice,
            updatePrice: updatePrice,
            cleanup: () => {
                if (searchInput && searchResults) {
                    searchInput.removeEventListener('input', inputHandler);
                    searchResults.removeEventListener('click', clickHandler);
                    document.removeEventListener('click', documentClickHandler);
                }
                if (gradeOptions) {
                    gradeOptions.removeEventListener('change', gradeChangeHandler);
                }
                if (addButton) {
                    addButton.removeEventListener('click', addButtonClickHandler);
                }
            }
        });

        if (selectedDevice) {
            updatePrice();
        }
    });
}

document.addEventListener('DOMContentLoaded', function () {
    updateTradeInDescriptions();
    initializeDeviceSearch();
    initializeTradeInValueAmounts();

    // Re-inicializar cuando cart drawer o modales Seedkit inyectan contenido con .device-search-input
    // MOXIE: se cambió de cart-drawer a document.body para cubrir comparadores cargados
    // vía Seedkit ajax-modal (data-ajax-url + data-ajax-iframe), que se inyectan en body
    // fuera del cart-drawer. El guard hasNewSearchInput mantiene el impacto en iOS mínimo.
    const tradeInObserver = new MutationObserver(function (mutations) {
        let hasNewSearchInput = false;
        for (var i = 0; i < mutations.length; i++) {
            var addedNodes = mutations[i].addedNodes;
            for (var j = 0; j < addedNodes.length; j++) {
                var node = addedNodes[j];
                if (node.nodeType !== 1) continue;
                if (
                    (node.classList && node.classList.contains('device-search-input')) ||
                    (node.querySelector && node.querySelector('.device-search-input'))
                ) {
                    hasNewSearchInput = true;
                    break;
                }
            }
            if (hasNewSearchInput) break;
        }
        if (hasNewSearchInput) {
            initializeDeviceSearch();
            updateTradeInDescriptions();
        }
    });

    tradeInObserver.observe(document.body, { childList: true, subtree: true });
});

function initializeTradeInValueAmounts() {
    const valueAmountElements = document.querySelectorAll('.js-trade-in-value-amount');
    valueAmountElements.forEach(element => {
        const rawValue = element.getAttribute('data-trade-in-value');
        if (rawValue && rawValue !== '0') {
            const formattedPrice = formatTradeInPrice(rawValue);
            element.textContent = formattedPrice;
        }
    });
}
